export default __webpack_public_path__ + "4b4cfa4bc3d2d5dc0dae8735ff082bfc.png";